// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"b3542595","390":"67e21ec9","516":"15a79ebf","589":"ff0c9345","686":"75b8c193"}[chunkId] + ".chunk.js";
};